import {
  ColorCriteria,
  EvidenceColumn,
  MeasurementType,
} from "../../../../../../store/onboarding/types";
import { Grade } from "../../../../../../store/groups/types";

export const getStudentsNum = (
  evidenceColumnStdScore: any[],
  colorCriteria: ColorCriteria,
  measurementType?: number,
  selectedGrade?: Grade
) => {
  if (measurementType !== MeasurementType.CATEGORY) {
    return evidenceColumnStdScore.filter(
      (score) => {
        if (colorCriteria) {
          if(selectedGrade) {
            return +score >= +colorCriteria.range_min! &&
               +score <= +colorCriteria.range_max!
          } else {
            return +score >= +colorCriteria.range_min! &&
               +score <= +colorCriteria.range_max!
          }
        }
      }
    ).length;
  } else {
    return evidenceColumnStdScore.filter(
      (score) => +score === colorCriteria.order
    ).length;
  }
};
